import { useEffect, useState } from 'react';
import { ShoppingItem } from '@/types';
import { getUserCategories } from '@/services/categories.service';
import { getProductForShoppingItem } from '@/services/shopping/items';

/**
 * Carica le informazioni aggiuntive per l'item da modificare.
 * @param item elemento di cui recuperare prodotto e categorie
 */
export const useEditItemData = (item?: ShoppingItem) => {
  const [product, setProduct] = useState<any>(null);
  const [categories, setCategories] = useState<any[]>([]);

  useEffect(() => {
    const loadProduct = async () => {
      if (!item) return;
      if ((item as any).product) {
        setProduct((item as any).product);
      } else if (item.product_id) {
        const productData = await getProductForShoppingItem(item.product_id);
        if (productData) {
          setProduct(productData);
        }
      }
    };

    const loadCategories = async () => {
      const userCategories = await getUserCategories();
      setCategories(userCategories);
    };

    loadProduct();
    loadCategories();
  }, [item]);

  return { product, categories };
};
